export enum MortgageTypeEnum {
    firsttime = "First-time buyer",
    secondtime = "Second-time buyer/Moving home",
    buytolet = "Buy-to-let",
    switchingmortgage = "Switching mortgage/Remortgage"
}